/**
 * Focus an editable element with the caret collapsed to its end — the landing
 * behavior for clicks that fall outside the text itself (the title row's
 * padding, the body's empty space below the content).
 */
export function focusWithCaretAtEnd(el: HTMLElement): void {
  el.focus()
  const range = document.createRange()
  range.selectNodeContents(el)
  range.collapse(false)
  const selection = window.getSelection()
  selection?.removeAllRanges()
  selection?.addRange(range)
}
